import React, { useEffect, useState } from "react";
import Main from "../Components/Main";
import PageContainer from "../Components/PageContainer";
import CollapseCard from "../Components/CollapseCard";
import TripFilter from "../Components/TripFilter";
import { Button, Table } from "react-bootstrap";
import { useToast } from "../Components/toast/ToastProvider";
import { filterTrips, getAllTrips } from "../Service/TripService";
import { getAllVehicles } from "../Service/VehicleService";
import { getAllVendors } from "../Service/VendorService";
import { getALLDestinations } from "../Service/DestinationService";
import { getAllSources } from "../Service/SourceService";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { Download } from "react-feather";
import { formatDate } from "../config/function";

const TripReportPage = () => {
  const [vendors, setVendors] = useState([]);
  const [vehicles, setVehicles] = useState([]);
  const [destination, setDestination] = useState([]);
  const [source, setSource] = useState([]);
  const [filters, setFilters] = useState({
    vendor_id: "",
    vehicle_id: "",
    from_date: "",
    to_date: "",
    status: "",
  });
  const [filteredTrips, setFilteredTrips] = useState([]);
  const [loading, setLoading] = useState(false);
  const toast = useToast();

  useEffect(() => {
    fetchVendors();
    fetchVehicles();
    fetchDestination();
    fetchSource();
  }, []);
  const fetchVendors = async () => {
    try {
      const res = await getAllVendors();
      setVendors(Array.isArray(res.data) ? res.data : []);
    } catch (err) {
      toast(err.message || "Failed to fetch vendors", "ERROR");
    }
  };

  const fetchVehicles = async () => {
    try {
      const res = await getAllVehicles();
      setVehicles(Array.isArray(res.data) ? res.data : []);
    } catch (err) {
      toast(err.message || "Failed to fetch vehicles", "ERROR");
    }
  };
  const fetchDestination = async () => {
    try {
      const res = await getALLDestinations();
      setDestination(res.data);
    } catch (err) {
      toast(err.message || "Failed to fetchDestination", "ERROR");
    }
  };
  const fetchSource = async () => {
    try {
      const res = await getAllSources();
      setSource(res.data);
    } catch (err) {
      toast(err.message || "failed to fetch Sources", "ERROR");
    }
  };

  const handleFilterChange = (name, value) => {
    setFilters((prev) => ({ ...prev, [name]: value }));

    if (name === "vendor_id") {
      setFilters((prev) => ({ ...prev, vehicle_id: "" }));
    }
  };
  const handleFind = async () => {
    setLoading(true);
    try {
      const res = await filterTrips(filters);
      console.log("res", res);

      setTimeout(() => {
        setFilteredTrips(res.data || []);
        setLoading(false);
      }, 1500);
    } catch (err) {
      toast(err.message || "Failed to filter trips", "ERROR");
    }
  };

  const handleReset = () => {
    setFilters({
      vendor_id: "",
      vehicle_id: "",
      from_date: "",
      to_date: "",
      status: "",
    });
    setFilteredTrips([]);
  };

  const filteredVehicles = filters.vendor_id
    ? vehicles.filter((v) => v.vendor_id == filters.vendor_id)
    : vehicles;

  const addPDFHeader = (doc, pageWidth) => {
    const logo = new Image();
    logo.src = "/img/asa_logo.png";

    const logoWidth = 18;
    const logoHeight = 18;
    const spacing = 5;

    const headerText = "ASA Transport";
    const subHeaderText = "Mannargudi";

    const headerWidth = doc.getTextWidth(headerText);
    const subHeaderWidth = doc.getTextWidth(subHeaderText);
    const totalWidth =
      logoWidth + spacing + Math.max(headerWidth, subHeaderWidth);
    const startX = (pageWidth - totalWidth) / 2;

    try {
      doc.addImage(logo, "PNG", startX, 8, logoWidth, logoHeight);
    } catch (e) {
      console.warn("Logo load skipped (small size optimization)");
    }

    doc.setFont("helvetica", "bold");
    doc.setFontSize(14);
    doc.text(headerText, startX + logoWidth + spacing, 14);

    doc.setFont("helvetica", "normal");
    doc.setFontSize(10);
    doc.text(subHeaderText, startX + logoWidth + spacing, 20);
  };

  const generateTablePDF = () => {
    if (filteredTrips.length === 0) {
      toast("No trips to export", "ERROR");
      return;
    }

    const capitalize = (str) => {
      if (!str) return "N/A";
      return str
        .toLowerCase()
        .split(" ")
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(" ");
    };

    const doc = new jsPDF({ orientation: "landscape", compress: true });
    const pageWidth = doc.internal.pageSize.getWidth();

    addPDFHeader(doc, pageWidth);

    doc.setFontSize(13);
    doc.setFont("helvetica", "bold");
    doc.text("Trip Details", pageWidth / 2, 35, { align: "center" });

    let selectedVendor = null;

    if (filters.vendor_id) {
      selectedVendor = vendors.find(
        (v) => v.id === parseInt(filters.vendor_id),
      );
    } else if (filters.vehicle_id) {
      const selectedVehicle = vehicles.find(
        (v) => v.id === parseInt(filters.vehicle_id),
      );

      if (selectedVehicle) {
        selectedVendor = vendors.find(
          (ven) => ven.id === selectedVehicle.vendor_id,
        );
      }
    }

    const vendorName = capitalize(selectedVendor?.name || "All Vendors");
    const vendorMobile = selectedVendor?.contact_number || "-";
    const vendorAddress = capitalize(selectedVendor?.location || "-");

    doc.setFont("helvetica", "normal");
    doc.setFontSize(9);

    let y = 45;
    doc.text(`Vendor Name: ${vendorName}`, 14, y);
    if (selectedVendor) {
      y += 6;
      doc.text(`Mobile: ${vendorMobile}`, 14, y);
      y += 6;
      doc.text(`Address: ${vendorAddress}`, 14, y);
    }

    const tableColumn = [
      "S.No",
      "Date",
      "Vendor",
      "Vehicle",
      "Source",
      "Destination",
      "Tones",
      "Total KM",
      "Rate",
      "Total Amount",
      "Weighment Charges",
      "Advance",
      "Balance",
    ];

    const tableRows = filteredTrips.map((trip, index) => {
      const vehicle = vehicles.find((v) => v.id === trip.vehicle_id);
      const vendor = vendors.find((ven) => ven.id === vehicle?.vendor_id);

      return [
        index + 1,
        formatDate(trip.date) || "N/A",
        capitalize(vendor?.name || "N/A"),
        vehicle?.vehicle_number || "N/A",
        capitalize(trip.source_name || "N/A"),
        capitalize(trip.destination_name || "N/A"),
        trip.total_tones || 0,
        trip.total_km || 0,
        trip.rate?.toFixed(2) || "0.00",
        trip.amount?.toFixed(2) || "0.00",
        trip.transition_charge?.toFixed(2) || "0.00",
        trip.advance_amount?.toFixed(2) || "0.00",
        trip.balance_amount?.toFixed(2) || "0.00",
      ];
    });
    autoTable(doc, {
      startY: y + 10,
      head: [tableColumn],
      body: tableRows,
      theme: "grid",
      styles: {
        fontSize: 8,
        cellPadding: 2,
        textColor: [0, 0, 0],
        lineColor: [0, 0, 0],
        lineWidth: 0.2,
      },
      headStyles: {
        fillColor: [255, 255, 255],
        textColor: [0, 0, 0],
        lineColor: [0, 0, 0],
        lineWidth: 0.2,
        fontStyle: "bold",
      },
    });

    const pdfOutput = doc.output("arraybuffer");
    const fileSizeKB = pdfOutput.byteLength / 1024;
    const fileSizeText =
      fileSizeKB > 1024
        ? `${(fileSizeKB / 1024).toFixed(2)} MB`
        : `${fileSizeKB.toFixed(2)} KB`;

    // toast(`PDF generated (${fileSizeText})`, "SUCCESS");

    const fileName = selectedVendor
      ? `Trip_Details${vendorName}.pdf`
      : "Trip_Details.pdf";

    doc.save(fileName);
  };

  const generateTripDetailsPDF = (trip) => {
    const doc = new jsPDF({ orientation: "portrait", compress: true });
    const pageWidth = doc.internal.pageSize.getWidth();

    addPDFHeader(doc, pageWidth);
    const capitalize = (str) => {
      if (!str) return "N/A";
      return str
        .toLowerCase()
        .split(" ")
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(" ");
    };
    doc.setFont("helvetica", "bold");
    doc.setFontSize(14);
    doc.text("Trip Receipt", pageWidth / 2, 45, { align: "center" });

    doc.setFont("helvetica", "bold");
    doc.setFontSize(10);
    doc.text(`Date: ${formatDate(trip.date)}`, 20, 59);

    doc.setFont("helvetica", "bold");
    doc.setFontSize(10);
    // doc.text(`Bill No:${trip.id}`,161,59);
    doc.text(`Bill No:${trip.bill_id}`, 161, 59);

    const vehicle = vehicles.find((v) => v.id === trip.vehicle_id);
    const vendor = vendors.find((ven) => ven.id === vehicle?.vendor_id);

    const leftDetails = [
      { label: "Vendor", value: capitalize(vendor?.name || "N/A") },
      { label: "Vehicle No", value: vehicle?.vehicle_number || "N/A" },
      { label: "Source", value: capitalize(trip.source_name || "N/A") },
      {
        label: "Destination",
        value: capitalize(trip.destination_name || "N/A"),
      },
      { label: "Tones", value: trip.total_tones || "0" },
    ];

    const rightDetails = [
      { label: "Total KM", value: trip.total_km || "0" },
      { label: "Amount", value: trip.amount?.toFixed(2) || "0.00" },
      {
        label: "weighment Charges",
        value: trip.transition_charge?.toFixed(2) || "0.00",
      },
      { label: "Advance", value: trip.advance_amount?.toFixed(2) || "0.00" },
      {
        label: "Balance Amount",
        value: trip.balance_amount?.toFixed(2) || "0.00",
      },
    ];

    let leftY = 72;
    let rightY = 72;
    doc.setFontSize(11);

    leftDetails.forEach((d) => {
      doc.setFont("helvetica", "bold");
      doc.text(`${d.label}:`, 25, leftY);
      doc.setFont("helvetica", "normal");
      doc.text(String(d.value || "N/A"), 50, leftY);
      leftY += 10;
    });

    rightDetails.forEach((d) => {
      doc.setFont("helvetica", "bold");
      doc.text(`${d.label}:`, 120, rightY);
      doc.setFont("helvetica", "normal");
      doc.text(String(d.value || "0.00"), 160, rightY);
      rightY += 10;
    });

    const pdfOutput = doc.output("arraybuffer");
    const fileSizeKB = pdfOutput.byteLength / 1024;
    const fileSizeText =
      fileSizeKB > 1024
        ? `${(fileSizeKB / 1024).toFixed(2)} MB`
        : `${fileSizeKB.toFixed(2)} KB`;

    doc.save(`Trip_${vendor?.name || "Report"}.pdf`);
  };

  return (
    <Main>
      <PageContainer>
        <CollapseCard title="Trip Filter">
          <TripFilter
            filters={filters}
            loading={loading}
            onFilterChange={handleFilterChange}
            vendors={vendors}
            vehicles={filteredVehicles}
            onFind={handleFind}
            onReset={handleReset}
          />
        </CollapseCard>

        <CollapseCard title="Trip Details">
          <Table size="sm">
            <thead>
              <tr>
                <th>S.No</th>
                <th>Date</th>
                <th>Vendor</th>
                <th>Vehicle</th>
                <th>Source</th>
                <th>Destination</th>
                <th>Tones</th>
                <th>Total KM</th>
                <th>Rate</th>
                <th>Total Amount</th>
                <th>Weighment Charges</th>
                <th>Advance</th>
                <th>Balance</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {filteredTrips.length > 0 ? (
                filteredTrips.map((trip, i) => {
                  const vehicle = vehicles.find(
                    (v) => v.id === trip.vehicle_id,
                  );
                  const vendor = vendors.find(
                    (ven) => ven.id === vehicle?.vendor_id,
                  );
                  return (
                    <tr key={trip.id}>
                      <td>{i + 1}</td>
                      <td style={{ whiteSpace: "nowrap", textAlign: "center" }}>
                        {formatDate(trip.date)}
                      </td>
                      <td style={{ whiteSpace: "nowrap", textAlign: "center" }}>
                        {vendor?.name || "N/A"}
                      </td>
                      <td style={{ whiteSpace: "nowrap", textAlign: "center" }}>
                        {vehicle?.vehicle_number || "N/A"}
                      </td>
                      <td>{trip.source_name || "N/A"}</td>
                      <td>{trip.destination_name || "N/A"}</td>
                      <td>{trip.total_tones}</td>
                      <td>{trip.total_km}</td>
                      <td>{trip.rate.toFixed(2)}</td>
                      <td>{trip.amount.toFixed(2)}</td>
                      <td>{trip.transition_charge.toFixed(2)}</td>
                      <td>{trip.advance_amount.toFixed(2)}</td>
                      <td>{trip.balance_amount.toFixed(2)}</td>
                      <td>
                        <Button
                          variant="primary"
                          size="sm"
                          onClick={() => generateTripDetailsPDF(trip)}
                        >
                          PDF
                        </Button>
                      </td>
                    </tr>
                  );
                })
              ) : (
                <tr>
                  <td colSpan={9} className="text-center">
                    No trip data found
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
        </CollapseCard>
        <div className="d-flex justify-content-end mb-2 mt-2">
          <Button variant="success" size="sm" onClick={generateTablePDF}>
            <Download /> Download PDF
          </Button>
        </div>
      </PageContainer>
    </Main>
  );
};
export default TripReportPage;
